import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { CopilotRecommendationBanner, CopilotThemesRecommendationDialog } from '@bingads-webui/inline-copilot';

export function ResponsiveSearchAdCopilotBannerWithDialog(props) {
  const {
    eventLog,
    isCopilotEnabled,
    onApply,
    onDialogFetchAssetsSucceeded,
    onFetch,
    onFetchFailed,
    onFetchSucceeded,
    onReset,
  } = props;

  const {
    logBannerRefresh,
    logBannerRefreshCompleted,
    logFetch,
    logFetchSucceeded,
  } = eventLog;

  const [showCopilotDialog, setShowCopilotDialog] = useState(false);

  const handleCopilotDialogClose = useCallback(() => {
    setShowCopilotDialog(false);
  }, []);

  const handleRefresh = useCallback(() => {
    setShowCopilotDialog(true);
    logBannerRefresh();
  }, [logBannerRefresh]);

  const handleFetchThemesSucceeded = useCallback((url, themesList) => {
    logFetchSucceeded(url, themesList);
  }, [logFetchSucceeded]);

  const handleApply = useCallback((selectedThemes, selectedThemesAndAssets) => {
    onApply(selectedThemes, selectedThemesAndAssets);
    handleCopilotDialogClose();
  }, [handleCopilotDialogClose, onApply]);

  if (!isCopilotEnabled) {
    // copilot is not enabled, do not display the banner or fetch any recommendations
    return null;
  }

  return (
    <React.Fragment>
      <CopilotRecommendationBanner
        isToastEnabled={false}
        onRefresh={handleRefresh}
        onReset={onReset}
        onBannerRefreshCompleted={logBannerRefreshCompleted}
        shouldFetchRecommendations
        onFetch={onFetch}
        onFetchFailed={onFetchFailed}
        onFetchSucceeded={onFetchSucceeded}
      />
      {showCopilotDialog && (
        <CopilotThemesRecommendationDialog
          onApply={handleApply}
          onClosed={handleCopilotDialogClose}
          onFetch={logFetch}
          onFetchAssetsSucceeded={onDialogFetchAssetsSucceeded}
          onFetchSucceeded={handleFetchThemesSucceeded}
          open
        />
      )}
    </React.Fragment>
  );
}

ResponsiveSearchAdCopilotBannerWithDialog.propTypes = {
  eventLog: PropTypes.shape({
    logBannerRefresh: PropTypes.func,
    logBannerRefreshCompleted: PropTypes.func,
    logFetch: PropTypes.func,
    logFetchSucceeded: PropTypes.func,
  }).isRequired,
  isCopilotEnabled: PropTypes.bool,
  onApply: PropTypes.func.isRequired,
  onDialogFetchAssetsSucceeded: PropTypes.func.isRequired,
  onFetch: PropTypes.func.isRequired,
  onFetchFailed: PropTypes.func.isRequired,
  onFetchSucceeded: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

ResponsiveSearchAdCopilotBannerWithDialog.defaultProps = {
  isCopilotEnabled: false,
};
